import styled from "styled-components";
import { StyleableSvgImage as StyleableSvgImageBase } from "@ubnt/store.core/lib/components/StyleableSvgImage";
import { BREAKPOINTS } from "layout";

export const PointsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 18px;

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    width: 100%;
    max-width: 850px;
    margin: 0 auto;
  }
`;

export const Point = styled.div`
  display: flex;
  gap: 16px;
  padding: 16px;
  background: ${({ theme }) => theme.colors.neutral01};
  border-radius: 4px;
  align-items: center;
  max-width: 440px;
  width: 100%;

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    max-width: unset;
  }
`;

export const CopyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
`;

export const Title = styled.span`
  color: ${({ theme }) => theme.colors.neutral11};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
`;

export const Description = styled.span`
  color: ${({ theme }) => theme.colors.neutral08};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;

  a {
    color: ${({ theme }) => theme.colors.ublue06};
    border-bottom: 1px solid ${({ theme }) => theme.colors.ublue06};
  }
`;

export const StyleableSvgImage = styled(StyleableSvgImageBase)`
  color: ${({ theme }) => theme.colors.ublue06};
`;
